import { Button } from "@/lib/components/Button/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/lib/components/Dialog";
import Toast from "@/lib/components/Toast";
import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import { useState } from "react";

export default function DeleteTrackDialog({
  open,
  onOpenChange,
  trackExternalId,
  trackName,
}: {
  open: boolean;
  onOpenChange: (isOpen: boolean) => void;
  trackExternalId: string;
  trackName: string;
}) {
  const [isDeleting, setIsDeleting] = useState(false);
  const deleteBackgroundMusic = useEditorStore(
    (state) => state.service.deleteBackgroundMusic,
  );

  const handleDelete = async () => {
    if (isDeleting) return;

    setIsDeleting(true);

    try {
      await deleteBackgroundMusic(trackExternalId);
      Toast.info("Track deleted successfully");
      onOpenChange(false);
    } catch (error) {
      console.error("Failed to delete track:", error);
      Toast.error("Failed to delete track");
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader className="w-full">
          <DialogTitle>Delete track</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete the track{" "}
            <span className="font-semibold">{trackName}</span>?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={handleDelete} disabled={isDeleting}>
            {isDeleting ? "Deleting..." : "Delete"}
          </Button>
          <DialogClose asChild>
            <Button type="button" variant="outline" disabled={isDeleting}>
              Cancel
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
